<!--  -->
<template>
  <div>
    <div class="table-top">
      <el-button v-if="!disabled" @click="addRow">添加一行</el-button>
    </div>
    <vxe-table border align="center" size="mini" :data="tableData" :edit-config="{ trigger: 'click', mode: 'row' }">
      <vxe-column align="center" title="序号" type="seq" width="60" />
      <vxe-column v-if="type === '1'" field="productCode" title="跳转产品">
        <template #default="{ row }">
          <el-select filterable placeholder="请选择" v-model="row.productCode" clearable @change="(e)=>prodectChange(row,e)">
            <el-option v-for="item in options" :key="item.productCode" :label="item.productName"
              :value="item.productCode">
            </el-option>
          </el-select>
        </template>
      </vxe-column>
      <vxe-column v-if="type === '3'" field="jumpType" title="跳转页面">
        <template #default="{ row }">
          <el-select filterable placeholder="请选择" v-model="row.jumpType" clearable @change="changeEvent">
            <el-option v-for="item in options" :key="item.dictCode" :label="item.dictValue" :value="item.dictCode">
            </el-option>
          </el-select>
        </template>
      </vxe-column>
      <vxe-column field="url" title="上传图片">
        <template #default="{ row }">
          <div>
            <UploadImage @change="(files) => changeFiles(files, row)" :value="row.url" :disabled="disabled">
            </UploadImage>
          </div>
        </template>
      </vxe-column>
      <vxe-column v-if="!disabled" title="操作" show-overflow width="80">
        <template #default="{ row }">
          <el-button type="danger" @click="removeEvent(row)" icon="el-icon-delete" circle></el-button>
        </template>
      </vxe-column>
    </vxe-table>
  </div>
</template>

<script>
import request from '@/found/utils/request';
import UploadImage from './upload_image.vue';

export default {
  components: { UploadImage },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    memberActivityType: {
      type: String,
      default: '',
    },
    fApi: Object,

  },
  data() {
    return {
      options: [],
      tableData: [],
    };
  },
  computed: {},
  mounted() { },
  methods: {
    // 获取产品
    getproductData() {
      const params = {
        enableStatus: '009',
        pageSize: '1000',
        productType: '1',
      };
      request.post('/cps/v1/memberIntegralProductInfo/memberIntegralProductInfo/findByConditions', params).then((res) => {
        if (res.success) {
          const { result } = res;
          this.options = result.data;
          const arr = this.tableData.map((val) => ({ ...val }));
          this.tableData = arr;
          this.changeEvent();
        }
      });
    },
    removeEvent(row) {
      this.tableData = this.tableData.filter((item) => item.id !== row.id);
      this.changeEvent();
    },
    addRow() {
      this.tableData.push({
        productCode: '',
        url: '',
        options: this.options,
        id: new Date().getTime() + Math.random() * 10000,
      });
      this.changeEvent();
    },

    changeFiles(files, row) {
      console.log(files, row, '888', this.tableData);
      this.tableData = this.tableData.map((el) => {
        if (el.id === row.id) {
          el.url = files[0] ? files[0].url : '';
        }
        return {
          ...el,
        };
      });
      this.changeEvent();
    },
    /* eslint-disable no-param-reassign */
    prodectChange(row, e) {
      console.log(e);
      const { productName } = this.options.find((item) => item.productCode === e);
      row.productName = productName;
      this.changeEvent();
    },
    /* eslint-enable no-param-reassign */
    changeEvent() {
      this.$emit('change', this.tableData);
      this.$emit('input', this.tableData);
    },
    // 获取跳转页面字典值
    getDioct() {
      request
        .post('/mdm/mdmdictdata/list', {
          dictTypeCode: 'member_goto_page',
        })
        .then((res) => {
          if (!res.success) return this.$message.error(res.message);
          this.options = res.result;
        });
    },
  },

  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(val) {
        console.log(val);
        this.tableData = val
          ? val.map((el) => ({
            ...el,
            id: el.id || new Date().getTime() + Math.random() * 10000,
          }))
          : [];
      },
    },
    memberActivityType: {
      deep: true,
      immediate: true,
      handler(val) {
        console.log(val, 9999);
        this.type = val;
        if (val === '1') {
          this.getproductData();
        }
        if (val === '3') {
          console.log('------获取数据字典');
          this.getDioct();
        }
      },
    },
  },
};
</script>

<style scoped lang="less">
.table-top {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}

/deep/.vxe-header--column .vxe-cell--title {
  line-height: inherit !important;
}
</style>
